export default {
  workflowMgr: {
    model: {
      category: {
        getList: '/api/workflow/processCategory/getList',
        getTreeData: '/api/workflow/processCategory/getTreeData',
        saveCategory: '/api/workflow/processCategory/saveCategory',
        updateCategory: '/api/workflow/processCategory/updateCategory',
        delCategory: '/api/workflow/processCategory/delCategory',
        getCategoryOptions: '/api/workflow/processCategory/getCategoryOptions',
      },
      process: {
        getUsers: '/api/workflow/processModel/getUsers',
        getGroups: '/api/workflow/processModel/getGroups',
        findListeners: '/api/workflow/processModel/findListeners',
        getList: '/api/workflow/processModel/getList',
        importXML: '/api/workflow/processModel/importXML',
        getXML: '/api/workflow/processModel/getXML',
        saveOrUpdateModel: '/api/workflow/processModel/saveOrUpdateModel',
        changeModelCategory: '/api/workflow/processModel/changeModelCategory',
        saveDraftXML: '/api/workflow/processModel/saveDraftXML',
        deleteModel: '/api/workflow/processModel/deleteModel',
        deployModel: '/api/workflow/processModel/deployModel',
        getDeployModel: '/api/workflow/processModel/getDeployModel',
        activate: '/api/workflow/processModel/activate',
        suspend: '/api/workflow/processModel/suspend',
        getDetail: '/api/workflow/processModel/detail',
        getImage: '/api/workflow/processModel/getImage',
        getFile: '/api/workflow/processModel/getFile',
        changeHandleType: '/api/workflow/processModel/changeHandleType',
        getImageWithFilePath: '/api/workflow/processModel/getImageWithFilePath',
        getFileWithPath: "/api/workflow/processModel/getFileWithPath",
      }
    },
    myaffairs: {
      todo: {
        getTodoCount: '/api/workflow/myaffairs/todo/getTodoCount',
        getList: '/api/workflow/myaffairs/todo/getList',
        getTaskForm: '/api/workflow/myaffairs/todo/getTaskForm',
        submitForm: '/api/workflow/myaffairs/todo/submitForm',
        delegateTask: '/api/workflow/myaffairs/todo/delegateTask',
        findReturnUserTask: '/api/workflow/myaffairs/todo/findReturnUserTask',
        flowReturn: '/api/workflow/myaffairs/todo/flowReturn'
      },
      startProcess: {
        getList: '/api/workflow/myaffairs/startProcess/getList',
        uploadProcessVariablesFile: '/api/workflow/myaffairs/startProcess/uploadProcessVariablesFile',
        startProcessWithVariables: "/api/workflow/myaffairs/startProcess/startProcessWithVariables",
      },
      startWithMe: {
        getList: '/api/workflow/myaffairs/startWithMe/getList',
      },
      participation: {
        getList: '/api/workflow/myaffairs/participation/getList',
      }
    },
    monitor: {
      getList: '/api/workflow/monitor/getList',
      getProcessInstanceDetail: '/api/workflow/monitor/getProcessInstanceDetail',
      deleteProcess: '/api/workflow/monitor/deleteProcess'
    },
  }

}